import { render, staticRenderFns } from "./creditcard-bonus.vue?vue&type=template&id=f6c8345e"
import script from "./creditcard-bonus.vue?vue&type=script&lang=js"
export * from "./creditcard-bonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports